<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp :activeButton="1" :userInfo="userData"       v-on:update="onStep1Update" />

    <div class="signup-page">
      <div class="container-fluid">
        <div class="row justify-content-md-center signup-inner-detail">
          <div class="col col-lg-6 col-md-8">
            <div class="logo text-center my-6">
              <h3>{{ "lng_menu_usersett" | translate }}</h3>
            </div>
            <div class="signup-form">
              <v-form ref="userInfo" lazy-validation>
                <v-text-field
                  :label="'lng_email_text' | translate"
                  type="email"
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_invoice_email_text' | translate"
                  type="email"
                  v-model="invoiceemail"
                  :rules="[rules.email]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_th_companyName_txt' | translate"
                  v-model="companyname"
                ></v-text-field>
                <v-text-field
                  :label="'lng_th_cvr_txt' | translate"
                  v-model="cvr"
                ></v-text-field>
                <v-text-field
                  :label="'lng_name_text' | translate"
                  v-model="name"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  :label="'lng_address1_text' | translate"
                  v-model="address1" :rules="[rules.required]"></v-text-field>
                <v-text-field
                  :label="'lng_address2_text' | translate"
                  v-model="address2"></v-text-field>
                <v-row>
                  <v-text-field
                    style="margin-right: 15px; margin-left: 15px;"
                    :label="'lng_zip_text' | translate"
                    v-model="zip"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    style="margin-right: 15px; margin-left: 15px;"
                    :label="'lng_city_text' | translate"
                    v-model="city"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-row>
                <!-- <v-text-field label="Country" name="country" type="text"></v-text-field> -->
                <v-select
                  class="mt-0 pt-0"
                  :items="countryItems"
                  :value="selectedCountry.value"
                  item-text="name"
                  item-value="value"
                  menu-props="auto"
                  return-object
                  @change="
                      value => {
                        selectedCountry = value;
                      }
                    "
                ></v-select>
                <v-text-field
                  :label="'lng_new_pass_txt' | translate"
                  v-model="newPass"></v-text-field>
                <v-text-field
                  :label="'lng_retype_pass_text' | translate"
                  v-model="retypeNewPass"></v-text-field>
                <p class="warning-error mt-2" v-if="error">{{ error }}</p>
                <div class="date-header d-flex justify-content-center py-5 mt-3">
                  <v-btn
                    :loading="showLoading"
                    color="#0B7894"
                    dark
                    @click="validate"
                  >{{ "lng_save_user_detail_btn" | translate }}</v-btn>
                </div>
              </v-form>
            </div>
          </div>
          <Alert
            v-if="alertToggle"
            :message-data="flashMessageData"
            :alert-toggle="alertToggle"
            @alertToggleUpdate="alertToggle = false"
          />
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import HeaderComp from "../../components/HeaderComp";
import { countries } from "../../common/Constant";
import UserService from "../../services/user-service";
import GlobalService from "../../services/global-service";
import { translateFunc } from '../../common/Filters.js';
import Alert from "../../components/Alert"
import onStep1Update from "../../mixins/ChangeLanguage"


export default {
  name: "UserSettings",
  components: {
    HeaderComp,
    Alert
  },
  data: () => ({
    showLoading: false,
    error: "",
    email: "",
    invoiceemail: "",
    companyname: "",
    cvr: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    zip: "",
    error: "",
    rules: {
      required: value => !!value || translateFunc("lng_required_text"),
      counter: value => value.length <= 20 || translateFunc("lng_required_length"),
      email: value => {
        if (!value) return true;
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || translateFunc("lng_required_validate_email");
      }
    },
    countryItems: countries,
    selectedCountry: {
      name: "Denmark",
      value: "DK"
    },
    userData: {},
    userToken: undefined,
    alertToggle: false,
    flashMessageData: {},
    newPass: "",
    retypeNewPass: ""
  }),
  mixins:[onStep1Update],
  mounted() {
    this.userToken = sessionStorage.getItem("userToken");
    // Always load profile for the current token. Cached userData can be
    // stale after "login as" (new tab clones the admin's sessionStorage).
    this.fetchUserInfo(this.userToken);
  },
  methods: {
    assignValues() {
      if (this.userData && this.userData) {
        this.email = this.userData.email || "";
        this.invoiceemail = this.userData.invoiceemail || "";
        this.companyname = this.userData.companyname || "";
        this.cvr = this.userData.cvr || "";
        this.name = this.userData.name || "";
        this.address1 = this.userData.address1;
        this.address2 = this.userData.address2;
        this.city = this.userData.city;
        this.zip = this.userData.zip;
        // country
        let index = countries.findIndex(
          e => e.name === this.userData.country
        );
        if (index !== -1) {
          this.selectedCountry = countries[index];
        }
      } else {
        this.fetchUserInfo(this.userToken);
      }
    },
    validate() {
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.userInfo.validate()) {
          // await this.signup();
          if (  this.address1 !== this.userData.address1 ||
                this.address2 !== this.userData.address2 ||
                this.city !== this.userData.city ||
                this.zip !== this.userData.zip ||
                this.selectedCountry !== this.userData.country
          ) {
            await this.getLatLng();
          } else {
            this.changeUserData({});
          }
        }
      });
      // this.openBoxModal = true;
    },

    async getLatLng() {
      let combinedAddress = `${this.address1} ${this.address2} ${this.city} ${this.zip} ${this.selectedCountry.name}`;
      let location = await UserService.googleApiForLatLng(combinedAddress);
      if (location.results.length) {
        await this.changeUserData(location.results[0].geometry.location);
      } else {
        console.log("location not found");
        this.error = translateFunc("lng_missing_city_txt");
        this.showAlert({msg: translateFunc("lng_missing_city_txt"), status: 1});
      }
    },

    async changeUserData(location) {
      this.error = "";
      this.showLoading = true;
      let response;
      try {
        let paramString = "";
        if (location.lat && location.lng) {
          paramString = `email=${encodeURIComponent(this.email)}&invoiceemail=${encodeURIComponent(this.invoiceemail)}&companyname=${encodeURIComponent(this.companyname)}&cvr=${encodeURIComponent(this.cvr)}&name=${encodeURIComponent(this.name)}&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(this.address2)}&city=${encodeURIComponent(this.city)}&zip=${this.zip}&country=${this.selectedCountry.name}&lat=${location.lat}&lng=${location.lng}&authlevel=1`;
        } else {
          paramString = `email=${encodeURIComponent(this.email)}&invoiceemail=${encodeURIComponent(this.invoiceemail)}&companyname=${encodeURIComponent(this.companyname)}&cvr=${encodeURIComponent(this.cvr)}&name=${encodeURIComponent(this.name)}&adr1=${encodeURIComponent(this.address1)}&adr2=${encodeURIComponent(this.address2)}&city=${encodeURIComponent(this.city)}&zip=${this.zip}&country=${this.selectedCountry.name}&authlevel=1`;
        }
        if(this.newPass){
          if(this.newPass === this.retypeNewPass){
            paramString = paramString + `&password=${this.newPass}`;

            response = await UserService.changeUserInfo(
              this.userToken,
              paramString
            );
          } else {
            response = {msg: translateFunc("lng_password_mismatch_txt"), status: 1}
          }
        } else {
          response = await UserService.changeUserInfo(
            this.userToken,
            paramString
          );
        }
      } catch (e) {
        this.error = translateFunc("lng_try_again_txt");
        this.showLoading = false;
        this.showAlert({msg: translateFunc("lng_try_again_txt"), status: 1});
      }
      if (!response.status) {
        this.error = "";
        this.showLoading = false;
        // sessionStorage.setItem("userToken", response.token);
        // router.push(`/`);
        this.showAlert(response);
        this.fetchUserInfo(this.userToken);
      } else {
        this.showLoading = false;
        this.error = response.msg;
        this.showAlert(response);
      }
    },
    async fetchUserInfo(token) {
      let userData = await GlobalService.getUserInfo(token);
      if (userData.dealer) {
        sessionStorage.setItem("userData", JSON.stringify(userData.dealer));
        this.userData = userData.dealer;
        this.assignValues();
      }
    },
    showAlert(res){
      this.flashMessageData = res;
      this.alertToggle = true;
    }
  }
};
</script>